export const selectOption = {
  timeOption: [
    {
      code: 0,
      desc: '全部'
    },
    {
      code: 1,
      desc: '今日'
    },
    {
      code: -1,
      desc: '昨日'
    },
    {
      code: 7,
      desc: '近7天'
    },
    {
      code: 30,
      desc: '近30天'
    }
  ]
}
export const codelist = {
  codeTableSum: [
    {
      name: '活动销售收入',
      code: 'income',
      tip: '查询时间内油站活动订单的销售收入（原价）'
    },
    {
      name: '活动销售升数',
      code: 'litre',
      tip: '查询时间内油站活动订单的加油升数'
    },
    {
      name: '活动订单人数',
      code: 'userNum',
      tip: '查询时间内油站活动订单的人数'
    },
    {
      name: '活动营销成本',
      code: 'costAmount',
      tip: '查询时间内该活动的商家让利金额'
    }
  ],
  dataTypeSumSS: [
    {
      name: '活动参与人数',
      code: 'joinUserNum',
      tip: '查询时间内该活动的参与人数'
    },
    {
      name: '活动领取人数',
      code: 'recieveCouUserNum',
      tip: '参与送水活动领取送水券用户数',
    },
    {
      name: '活动核销人数',
      code: 'usedCouUserNum',
      tip: '参与送水活动核销送水券用户数',
    },
    {
      name: '活动销售收入',
      code: 'income',
      tip: '查询时间内油站活动订单的销售收入（原价）',
    }
  ],
  codeTable:[
    [
      {code: 'joinUserNum', name: '活动参与人数', tip: '查询时间内该活动的参与人数'},
      {code: 'orderNum', name: '活动订单数', tip: '查询时间内该活动的订单笔数合计'},
      {code: 'orderRate', name: '活动订单占比', tip: '查询时间内活动订单量/总订单量'}
    ],
    [
      {code: 'realIncome', name: '活动实际销售收入', tip: '查询时间内活动订单用户实际付款金额'},
      {code: 'oldUserRealIncome', name: '老用户实际销售收入', tip: '查询时间内非油站首单用户实际付款金额'},
      {code: 'newUserRealIncome', name: '新用户实际销售收入', tip: '查询时间内油站首单用户实际付款金额'}
    ],
    [
      {code: 'oldUserLitre', name: '老用户订单升数', tip: '查询时间内非油站首单用户订单加油升数'},
      {code: 'newUserLitre', name: '新用户订单升数', tip: '查询时间内油站首单订单加油升数'},
      {code: 'oldUserNum', name: '老用户订单人数', tip: '查询时间内非油站首单订单人数'},
      {code: 'newUserNum', name: '新用户订单人数', tip: '查询时间内油站首单订单人数', style: 'margin-top:30px'}
    ],
    [
      {code: 'costRate', name: '活动力度', tip: '商家让利金额/活动订单中的用户实付金额'},
      {code: 'orderFinishRate', name: '转化率', tip: '查询时间内活动类型订单除以该站全部订单'},
    ]
  ],
  codeTableXsms:[
    [
      {code: 'joinUserNum', name: '活动参与人数', tip: '查询时间内该活动的参与人数'},
      {code: 'orderNum', name: '活动订单数', tip: '查询时间内该活动的订单笔数合计'},
      {code: 'disActivityIncome', name: '非活动销售收入', tip: '油站销售收入-活动销售收入'},
    ],
    [
      {code: 'realIncome', name: '活动实际销售收入', tip: '查询时间内活动订单用户实际付款金额'},
      {code: 'oldUserRealIncome', name: '老用户实际销售收入', tip: '查询时间内非油站首单用户实际付款金额'},
      {code: 'newUserRealIncome', name: '新用户实际销售收入', tip: '查询时间内油站首单用户实际付款金额'}
    ],
    [
      {code: 'oldUserLitre', name: '老用户订单升数', tip: '查询时间内非油站首单用户订单加油升数'},
      {code: 'newUserLitre', name: '新用户订单升数', tip: '查询时间内油站首单订单加油升数'},
      {code: 'oldUserNum', name: '老用户订单人数', tip: '查询时间内非油站首单订单人数'},
      {code: 'newUserNum', name: '新用户订单人数', tip: '查询时间内油站首单订单人数', style: 'margin-top:30px'}
    ],
    [
      {code: 'costRate', name: '活动力度', tip: '商家让利金额/活动订单中的用户实付金额'},
      {code: 'orderFinishRate', name: '转化率', tip: '查询时间内活动类型订单除以该站全部订单'},
      {code: 'orderRate', name: '活动订单占比', tip: '查询时间内活动订单量/总订单量'}

    ]
  ],
  codeTableSS: [
    {code: 'orderNum', name: '活动订单数', tip: '查询时间内该活动的订单笔数合计'},
    {code: 'orderRate', name: '活动订单占比', tip: '查询时间内活动订单量/总订单量'},
    {code: 'realIncome', name: '活动实际销售收入', tip: '查询时间内活动订单用户实际付款金额'},
    {code: 'oldUserRealIncome', name: '老用户实际销售收入', tip: '查询时间内非油站首单用户实际付款金额'},
    {code: 'newUserRealIncome', name: '新用户实际销售收入', tip: '查询时间内油站首单用户实际付款金额'},
    {code: 'newUserNum', name: '新用户订单人数', tip: '查询时间内油站首单订单人数'},
    {code: 'oldUserNum', name: '老用户订单人数', tip: '查询时间内非油站首单订单人数'}
  ]
}
export const column = [
  { label: '活动名称', prop: 'activityName', fixed: true, width:'150', slot: true },
  { label: '活动时间', prop: 'activityTime', width:'180'},
  { label: '活动销售收入', prop: 'activityAmount', width:'120', unit: '元'},
  { label: '活动销售升数', prop: 'activityLitre', width:'120', unit: '升'},
  { label: '活动订单人数', prop: 'activityUserNum', width:'120', unit: '人'}
]

// 元单位计算
export function yuanUnit (num) {
  if(!num && num !== 0) return '-'
  if (num < 10000) {
    return num
  } else if (num >= 10000 && num < 10000*10000){
    return Math.round(num/100)/100 + '万'
  } else if (num >= 10000*10000 && num < 10e9*10000) {
    return Math.round(num/(100*10000))/100 +'亿'
  } else {
    return Math.round(num/(10e7*10000))/100 +'万亿'
  }
}
